<template>
  <div class="ecm__checkout section__padding" v-loading.fullscreen.lock="isLoading">
    <div class="ecm__checkout-address" v-if="mainAddress">
      <UserAddress
        ref="userAddressRef"
        @handleFetchShipmentsAddress="handleFetchShipmentsAddress"
      />
      <div class="ecm__checkout-address__title">
        <i class="fas fa-map-marker-alt"></i>
        <p>Shipping address</p>
        <button @click="handleShowUserAddress">
          <i class="fas fa-pen"></i>
        </button>
        <AddAddress
          ref="addAddressRef"
          @handleFetchShipmentsAddress="handleFetchShipmentsAddress"
        />
      </div>
      <div class="ecm__checkout-address__desc">
        <div class="ecm__checkout-address__desc-receiver">
          <p>{{ mainAddress.receiver }}</p>
          <p>Phone: {{ mainAddress.phone_number }}</p>
        </div>
        <div class="ecm__checkout-address__desc-address">
          <p>{{ formatAddress(mainAddress.detail_address, mainAddress.province, mainAddress.city, mainAddress.postal_code) }}</p>
        </div>
      </div>
    </div>
    <div class="ecm__checkout-items">
      <p class="ecm__checkout-items__title">Books Ordered</p>
      <div class="ecm__checkout-items__container">
        <div
          class="ecm__checkout-items__container-item"
          v-for="(item) in shipments" :key="item.id"
        >
          <div class="ecm__checkout-items__container-item__cover">
            <img :src="item.Book.cover" alt="">
          </div>
          <div class="ecm__checkout-items__container-item__desc">
            <p>{{ item.Book.title }}</p>
          </div>
          <div class="ecm__checkout-items__container-item__price">
            <p>Rp {{ formatPrice(item.Book.price) }}</p>
          </div>
          <div class="ecm__checkout-items__container-item__quantity">
            <p>{{ item.quantity }} Pcs</p>
          </div>
          <div class="ecm__checkout-items__container-item__total">
            <p>Rp {{ formatPrice(item.Book.price * item.quantity) }}</p>
          </div>
        </div>
        <div class="ecm__checkout-items__container-courier" v-if="courier.costId">
          <Cost ref="costRef" @handleCourierCost="handleCourierCost" :courier="courier"/>
          <div class="ecm__checkout-items__container-courier__container">
            <p class="ecm__checkout-items__container-courier__container-title">Shipping options</p>
            <div class="ecm__checkout-items__container-courier__container-desc">
              <p class="ecm__checkout-items__container-courier__container-desc-name">{{ courier.courierName }}</p>
              <p class="ecm__checkout-items__container-courier__container-desc-estimate">{{ formatDaysCourier(courier.etd) }}</p>
            </div>
            <p class="ecm__checkout-items__container-courier__container-editbtn">
              <button @click="handleShowCostDialog">EDIT</button>
            </p>
            <p class="ecm__checkout-items__container-courier__container-price">Rp {{ formatPrice(courier.cost) }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="ecm__checkout-cost" v-if="total && courier.costId">
      <div class="ecm__checkout-cost__method">
        <p v-for="(payment, index) in paymentMethods"
          :key="index"
          :class="[payment == paymentType ? 'ecm__checkout-cost__method-payment active' : 'ecm__checkout-cost__method-payment']"
          @click="handleSetPaymentType(payment)"
        >{{ payment }}</p>
      </div>
      <div class="ecm__checkout-cost__checkout">
        <div class="ecm__checkout-cost__checkout-item">
          <p class="ecm__checkout-cost__checkout-item__title">Sub Total for Books</p>
          <p class="ecm__checkout-cost__checkout-item__desc">Rp {{ formatPrice(total.booksPrice) }}</p>
        </div>
        <div class="ecm__checkout-cost__checkout-item">
          <p class="ecm__checkout-cost__checkout-item__title">Total Shipping Cost</p>
          <p class="ecm__checkout-cost__checkout-item__desc">Rp {{ formatPrice(courier.cost) }}</p>
        </div>
        <div class="ecm__checkout-cost__checkout-item">
          <p class="ecm__checkout-cost__checkout-item__title">Total Payment</p>
          <p class="ecm__checkout-cost__checkout-item__desc total">Rp {{ formatPrice(courier.cost + total.booksPrice) }}</p>
        </div>
      </div>
    </div>
    <div class="ecm__checkout-process" v-if="total && courier.costId">
      <button
        :disabled="true"
        class="ecm__checkout-process__btn"
        @click="handleOrder"
      >Order now</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import formatDisplay from '@/mixins/formatDisplay.js'
import Cost from '@/components/modals/Cost'
import UserAddress from '@/components/modals/UserAddress'
import AddAddress from '@/components/modals/AddAddress'

export default {
  name: 'Checkout',
  mixins: [formatDisplay],
  components: {
    Cost,
    UserAddress,
    AddAddress
  },
  data () {
    return {
      isLoading: true,
      courier: {
        costId: null,
        courierName: '',
        cost: 0,
        etd: '',
        code: ''
      },
      total: null,
      paymentMethods: ['mandiri'],
      paymentType: 'mandiri'
    }
  },
  mounted () {
    this.$root.$on('showCreateAddress', (payload) => {
      this.$refs.addAddressRef.setIsShow(payload)
    })
    this.handleFetchShipmentsAddress()
  },
  computed: {
    ...mapState({
      addresses: state => state.address.addresses,
      shipments: state => state.shipment.shipments
    }),
    ...mapGetters({
      mainAddress: 'address/getMainAddress'
    })
  },
  methods: {
    ...mapActions({
      fetchAddresses: 'address/fetchAddresses',
      fetchShipments: 'shipment/fetchShipments',
      fetchCourier: 'cost/fetchCourier',
      checkout: 'order/checkout'
    }),
    handleSetPaymentType (payment) {
      this.$data.paymentType = payment
    },
    handleShowUserAddress () {
      this.$refs.userAddressRef.setIsShow(true)
    },
    handleShowCostDialog () {
      this.$refs.costRef.setIsShow(true)
      this.$refs.costRef.setActiveTab()
    },
    handleOrder () {
      this.isLoading = true
      let totalPrice = 0
      const books = []
      this.shipments.forEach(item => {
        totalPrice += item.quantity * item.Book.price
        books.push({ book_id: item.Book.id, quantity: item.quantity })
      })
      const courier = `${this.courier.code.toUpperCase()}-${this.courier.courierName}`
      this.checkout({
        payment_method: this.$data.paymentType,
        total_price: totalPrice,
        courier,
        cost: this.courier.cost,
        user_address_id: this.mainAddress.id,
        books
      })
        .then(resp => {
          if (resp.data.msg === 'successfully create order') {
            this.$router.push('/detail/transaction/' + resp.data.data.id)
          }
        })
        .catch(err => {
          console.warn(err)
          this.$message({
            showClose: true,
            message: 'Sorry, there was an error with the system',
            type: 'error'
          })
        })
        .finally(_ => {
          setTimeout(() => {
            this.$data.isLoading = false
            this.handleFetchShipmentsAddress()
          }, 500)
        })
    },
    handleCourierCost ({ courierName, costId, cost, etd, code }) {
      this.$data.courier = { costId, courierName, cost, etd, code }
    },
    async handleFetchShipmentsAddress () {
      try {
        await this.fetchAddresses()
        await this.fetchShipments()
        let totalPrice = 0
        this.shipments.forEach(item => {
          totalPrice += item.quantity * item.Book.price
        })
        this.$data.total = { booksPrice: totalPrice }
        this.handleFetchCourier()
      } catch (error) {
        console.log(error)
      } finally {
        setTimeout(() => {
          this.$data.isLoading = false
        }, 500)
      }
    },
    handleFetchCourier () {
      this.$data.courier.costId = null
      let weight = 0
      this.shipments.forEach(el => {
        weight += el.quantity * 300
      })
      Promise.all([
        this.fetchCourier({
          origin: this.mainAddress.province_id,
          destination: this.mainAddress.city_id,
          courier: 'jne',
          weight
        }),
        this.fetchCourier({
          origin: this.mainAddress.province_id,
          destination: this.mainAddress.city_id,
          courier: 'pos',
          weight
        }),
        this.fetchCourier({
          origin: this.mainAddress.province_id,
          destination: this.mainAddress.city_id,
          courier: 'tiki',
          weight
        })
      ])
        .then(resp => {
          if (this.$data.courier.costId === null) {
            if (resp.length > 0) {
              resp.forEach(courier => {
                if (Array.isArray(courier)) {
                  if (courier.length > 0) {
                    courier.forEach(service => {
                      if (service.costs.length > 0) {
                        service.costs.forEach(cost => {
                          if (cost.cost.length > 0) {
                            cost.cost.forEach(costDesc => {
                              this.$data.courier = {
                                costId: costDesc.id,
                                courierName: service.name,
                                cost: costDesc.value,
                                etd: costDesc.etd,
                                code: service.code
                              }
                              return true
                            })
                          }
                        })
                      }
                    })
                    return true
                  }
                }
              })
            }
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__checkout {
  .ecm__checkout-address {
    padding: 20px;
    border: 1px solid rgba(0, 0, 0, 0.241);
    background: rgb(29,55,105);
    background: linear-gradient(315deg, rgba(29,55,105,1) 0%, rgba(9,35,87,1) 100%);
    color: white;
    position: relative;
    .ecm__checkout-address__title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 20px;
      padding: 0 0 10px 0;
      .fa-map-marker-alt {
        margin-right: 10px;
      }
      button {
        font-size: 18px;
        background: none;
        border: none;
        outline: none;
        color: white;
        cursor: pointer;
        margin-left: 20px;
      }
    }
    .ecm__checkout-address__desc {
      display: flex;
      .ecm__checkout-address__desc-receiver {
        flex: .2;
        p {
          font-weight: 500;
        }
      }
      .ecm__checkout-address__desc-address {
        flex: .6;
      }
    }
  }
  .ecm__checkout-items {
    margin: 15px 0;
    padding: 20px;
    border: 1px solid rgba(0, 0, 0, 0.241);
    .ecm__checkout-items__title {
      font-size: 20px;
      font-weight: 600;
      color: var(--color-blue-background);
    }
    .ecm__checkout-items__container {
      margin-top: 10px;
      .ecm__checkout-items__container-item {
        border-bottom: 1px solid rgba(0, 0, 0, 0.241);
        display: flex;
        &:last-child {
          border-bottom: 0;
        }
        .ecm__checkout-items__container-item__cover {
          height: 90px;
          overflow: hidden;
          margin: 10px 0;
          img {
            height: 100%;
          }
        }
        .ecm__checkout-items__container-item__desc,
        .ecm__checkout-items__container-item__price,
        .ecm__checkout-items__container-item__quantity,
        .ecm__checkout-items__container-item__total {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 10px;
          flex: .1;
          font-weight: 500;
        }
        .ecm__checkout-items__container-item__desc {
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          flex: .7;
        }
        .ecm__checkout-items__container-item__price {
          p {
            color: var(--color-pink);
          }
        }
      }
      .ecm__checkout-items__container-courier {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background: #FAFDFF;
        padding: 10px 0;
        font-size: 16px;
        .ecm__checkout-items__container-courier__container {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-right: 15px;
          color: rgba(0, 0, 0, 0.844);
          .ecm__checkout-items__container-courier__container-title {
            color: var(--color-blue-background);
            font-weight: 600;
          }
          .ecm__checkout-items__container-courier__container-desc {
            padding: 0 25px;
            font-weight: 500;
            width: 300px;
          }
          .ecm__checkout-items__container-courier__container-editbtn {
            padding: 0 20px;
            button {
              background: none;
              border: none;
              outline: none;
              font-size: 15px;
              cursor: pointer;
              color: var(--color-blue-background);
              font-weight: 600;
            }
          }
          .ecm__checkout-items__container-courier__container-price {
            font-weight: 500;
          }
        }
      }
    }
  }
  .ecm__checkout-cost {
    padding: 20px;
    border: 1px solid rgba(0, 0, 0, 0.241);
    display: flex;
    .ecm__checkout-cost__method,
    .ecm__checkout-cost__checkout {
      display: flex;
      justify-content: flex-start;
    }
    .ecm__checkout-cost__method {
      flex: .7;
      align-items: flex-start;
      flex-wrap: wrap;
      .ecm__checkout-cost__method-payment {
        color: grey;
        border: 1px solid grey;
        padding: 3px 7px;
        margin: 0 10px 10px 0;
        cursor: pointer;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 15px;
        border-radius: 2px;
        &.active {
          cursor: default;
          color: var(--color-blue-background);
          border: 1px solid var(--color-blue-background);
        }
      }
    }
    .ecm__checkout-cost__checkout {
      flex: .3;
      align-items: flex-end;
      flex-direction: column;
      margin-right: 15px;
      .ecm__checkout-cost__checkout-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 350px;
        .ecm__checkout-cost__checkout-item__desc {
          &.total {
            font-size: 30px;
            font-weight: 500;
            color: var(--color-pink);
          }
        }
      }
    }
  }
  .ecm__checkout-process {
    padding: 20px;
    border: 1px solid rgba(0, 0, 0, 0.241);
    border-top: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .ecm__checkout-process__btn {
      background: var(--color-blue-background);
      border: none;
      outline: none;
      font-size: 18px;
      font-weight: 500;
      color: white;
      padding: 3px 18px;
      cursor: pointer;
      &:disabled {
        cursor: not-allowed;
      }
    }
  }
}
</style>
